import React from "react";
import { useT } from "@/context/I18nContext";
import { Link } from "react-router-dom";
import { Mail, BookOpen, ShieldCheck, Trash2 } from "lucide-react";

const SUPPORT_EMAIL = "support@innercompass.tech";

export default function Support() {
  const t = useT();
  const cards = [
    {
      to: "/privacy",
      icon: <ShieldCheck className="h-5 w-5 text-sage-600" strokeWidth={1.75} />,
      title: t("public.support.card.privacy.title"),
      body: t("public.support.card.privacy.body"),
      testId: "support-card-privacy",
    },
    {
      to: "/terms",
      icon: <BookOpen className="h-5 w-5 text-sage-600" strokeWidth={1.75} />,
      title: t("public.support.card.terms.title"),
      body: t("public.support.card.terms.body"),
      testId: "support-card-terms",
    },
    {
      to: "/delete-account",
      icon: <Trash2 className="h-5 w-5 text-terracotta-500" strokeWidth={1.75} />,
      title: t("public.support.card.delete.title"),
      body: t("public.support.card.delete.body"),
      testId: "support-card-delete",
    },
    {
      to: "/safety",
      icon: <ShieldCheck className="h-5 w-5 text-sage-600" strokeWidth={1.75} />,
      title: t("public.support.card.safety.title"),
      body: t("public.support.card.safety.body"),
      testId: "support-card-safety",
    },
  ];

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-10 md:py-16" data-testid="page-support">
      <header className="mb-8">
        <h1 className="font-heading text-3xl md:text-5xl tracking-tight text-ink-900">
          {t("public.support.title")}
        </h1>
        <p className="mt-3 text-ink-500 text-base md:text-lg max-w-2xl">
          {t("public.support.subtitle")}
        </p>
      </header>

      <section className="rounded-3xl bg-white shadow-card p-6 md:p-8 mb-8" data-testid="support-contact-block">
        <div className="flex items-center gap-2 mb-2">
          <Mail className="h-5 w-5 text-sage-600" strokeWidth={1.75} />
          <h2 className="font-heading text-xl">{t("public.support.contact.heading")}</h2>
        </div>
        <p className="text-sm md:text-base text-ink-700 leading-relaxed mb-3">
          {t("public.support.contact.body")}
        </p>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          data-testid="support-email-link"
          className="inline-flex items-center rounded-full bg-ink-900 text-white px-5 py-2 text-sm hover:bg-ink-700"
        >
          {SUPPORT_EMAIL}
        </a>
      </section>

      <div className="grid gap-4 md:grid-cols-2" data-testid="support-cards">
        {cards.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            data-testid={c.testId}
            className="rounded-3xl bg-white shadow-card p-6 hover:-translate-y-0.5 transition"
          >
            <div className="flex items-center gap-2 mb-2">{c.icon}<div className="font-heading text-lg">{c.title}</div></div>
            <p className="text-sm text-ink-700 leading-relaxed">{c.body}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
